<template>
    <div>

    </div>
</template>
<script>
export default {
    name: 'ContractExpiredError',
    data() {
        return {
            message: '계약 등록시간이 마감되었습니다',
        };
    },
    created() {
        alert(this.message);
        window.close()
    },
};
</script>